import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './less_chip.less';
export function LessChip({ detail = 'Less support' }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: "less-chip",
        "data-kind": "less",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "less-chip__label",
                children: "less"
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "less-chip__detail",
                children: detail
            })
        ]
    });
}


export const knightedCss = ".less-chip,.knighted-less-chip,.knighted-knighted-less-chip{color:#bae6fd;letter-spacing:.04em;text-transform:uppercase;background:#0e749033;border:1px solid #22d3ee80;border-radius:999px;align-items:center;gap:.5rem;padding:.55rem .9rem;font-size:.85rem;display:inline-flex;box-shadow:0 10px 18px #22d3ee40}.less-chip__label,.knighted-less-chip__label,.knighted-knighted-less-chip__label{font-weight:700}.less-chip__detail,.knighted-less-chip__detail,.knighted-knighted-less-chip__detail{opacity:.85}";
